export default __webpack_public_path__ + "static/media/volkihar-slide-3-large.005b69f2.jpg";